"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotifyPlaylistModule = void 0;
const base_1 = require("./base");
class SpotifyPlaylistModule extends base_1.SurveyModule {
    constructor(props) {
        super(props);
        this._type = "SpotifyPlaylist";
        this.actionRequired = !props.data;
    }
    validate() {
        return this.data ? true : false;
    }
    toBuilderConfig() {
        return {
            id: this.id,
            type: this.type,
            actionRequired: this.actionRequired,
            style: this.style,
            data: this.data,
        };
    }
    toSurveyConfig() {
        return {
            id: this.id,
            type: this.type,
            actionRequired: this.actionRequired,
            style: this.style,
            data: this.data,
        };
    }
    editProps() {
        return undefined;
    }
}
exports.SpotifyPlaylistModule = SpotifyPlaylistModule;
//# sourceMappingURL=SpotifyPlaylist.js.map